import React from "react";
import policyMd from "../data/privacyPolicy";

export default function PrivacyPolicyPage() {
  return (
    <main>
      {/* Hero */}
      <section className="relative h-60 w-full overflow-hidden md:h-80">
        <img
          src="/privacy/adatvedelem.jpg"
          alt="Adatvédelem"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50" />
        <h1 className="relative z-10 flex h-full items-center justify-center text-3xl font-bold text-white md:text-4xl">
          Adatkezelési tájékoztató
        </h1>
      </section>

      {/* Content */}
      <article className="prose mx-auto max-w-4xl px-4 py-12 prose-h2:text-primary prose-a:text-primary">
        <p className="whitespace-pre-line">{policyMd}</p>
      </article>

      {/* Download link */}
      <p className="mb-20 text-center text-sm text-gray-600">
        A tájékoztatót PDF formátumban is letöltheti: {" "}
        <a href="/privacy/adatvedelem.pdf" className="underline text-primary" download>
          adatvedelem.pdf
        </a>
      </p>
    </main>
  );
}
